export enum ProductSelectFromEnum {
  TTZ = "220",
  NAVER = "naver",
  MY = "my",
}
